import Vue from 'vue'

export default {
  sendMessage({customerId, text, channel}) {
    return Vue.http.post(`conversations/${customerId}`, {text, channel}).then(res => res.body)
  },
  getCustomerMessages(customerId) {
    return Vue.http.get(`conversations/${customerId}`).then(res => res.body)
  }
}
